import { useState } from "react";
import { UserPlus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { useAuth } from "@/lib/auth";
import { STAFF } from "@/lib/nav";
import { SingleUploadFlow } from "@/components/intake/SingleUploadFlow";

export function AddCandidateButton({ jobId, testId = "add-candidate-btn", variant = "default", size = "default" }) {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [key, setKey] = useState(0);
  if (!STAFF.includes(user?.role)) return null;
  return (
    <>
      <Button variant={variant} size={size} onClick={() => { setKey((k) => k + 1); setOpen(true); }} data-testid={testId}><UserPlus size={16} aria-hidden="true" /> Add candidate</Button>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="right" className="w-full overflow-y-auto sm:max-w-2xl" data-testid="add-candidate-sheet">
          <SheetHeader className="mb-6 text-left">
            <SheetTitle className="font-display text-xl">Add a candidate</SheetTitle>
            <SheetDescription>Upload one resume. We read it in the background, then you check the details before anything is saved.</SheetDescription>
          </SheetHeader>
          <SingleUploadFlow key={key} jobId={jobId} onDone={() => setOpen(false)} />
        </SheetContent>
      </Sheet>
    </>
  );
}
